(function () {
  function parseEndDate(rawValue) {
    if (!rawValue) return NaN;
    return Date.parse(rawValue);
  }

  function formatCountdown(distance) {
    var safeDistance = Math.max(distance, 0);
    var totalSeconds = Math.floor(safeDistance / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return [hours, minutes, seconds]
      .map(function (value, index) {
        var suffix = ['H', 'M', 'S'][index];
        return String(value).padStart(2, '0') + ' ' + suffix;
      })
      .join(' : ');
  }

  function initCountdown(section) {
    var countdown = section.querySelector('[data-vo-countdown]');

    if (!countdown || countdown.dataset.voCountdownReady === 'true') return;

    var countdownTimer = countdown.querySelector('.vo-full-width-banner__countdown-timer');
    var endDate = parseEndDate(countdown.dataset.end);

    if (!countdownTimer || Number.isNaN(endDate)) {
      countdown.hidden = true;
      return;
    }

    countdown.dataset.voCountdownReady = 'true';

    var tick = function () {
      var distance = endDate - Date.now();

      if (distance <= 0) {
        countdown.hidden = true;
        window.clearInterval(intervalId);
        return;
      }

      countdownTimer.textContent = formatCountdown(distance);
    };

    tick();
    var intervalId = window.setInterval(tick, 1000);
  }

  function syncVideoUi(section, video) {
    var playIcon = section.querySelector('[data-vo-icon-play]');
    var pauseIcon = section.querySelector('[data-vo-icon-pause]');
    var audioOnIcon = section.querySelector('[data-vo-icon-audio-on]');
    var audioOffIcon = section.querySelector('[data-vo-icon-audio-off]');
    var playButton = section.querySelector('[data-vo-video-toggle]');
    var audioButton = section.querySelector('[data-vo-audio-toggle]');

    if (!video) return;

    section.classList.toggle('is-video-paused', video.paused);
    section.classList.toggle('is-video-playing', !video.paused);

    if (playIcon) playIcon.hidden = !video.paused;
    if (pauseIcon) pauseIcon.hidden = video.paused;
    if (audioOnIcon) audioOnIcon.hidden = video.muted;
    if (audioOffIcon) audioOffIcon.hidden = !video.muted;
    if (playButton) {
      playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }
    if (audioButton) {
      audioButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }
  }

  function getActiveVideo(videos) {
    if (!videos || !videos.length) return null;

    for (var i = 0; i < videos.length; i += 1) {
      if (videos[i].offsetParent !== null) {
        return videos[i];
      }
    }

    return videos[0];
  }

  function initVideo(section) {
    var videos = Array.from(section.querySelectorAll('[data-vo-video], [data-vo-video-wrapper] video'));

    if (!videos.length || section.dataset.voVideoReady === 'true') return;

    var playButton = section.querySelector('[data-vo-video-toggle]');
    var audioButton = section.querySelector('[data-vo-audio-toggle]');
    var mobileMedia = window.matchMedia('(max-width: 749px)');

    var requestPlayback = function (video) {
      if (!video) return;
      var playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            if (video === getActiveVideo(videos)) {
              section.classList.remove('is-video-fallback');
              syncVideoUi(section, video);
            }
          })
          .catch(function () {
            if (video === getActiveVideo(videos)) {
              section.classList.add('is-video-fallback');
              syncVideoUi(section, video);
            }
          });
      } else if (video === getActiveVideo(videos)) {
        syncVideoUi(section, video);
      }
    };

    var syncActiveVideo = function () {
      var activeVideo = getActiveVideo(videos);

      section.classList.remove('is-video-fallback');
      videos.forEach(function (video) {
        if (video !== activeVideo && !video.paused) {
          video.pause();
        }
      });

      requestPlayback(activeVideo);
      syncVideoUi(section, activeVideo);
    };

    section.dataset.voVideoReady = 'true';

    videos.forEach(function (video) {
      if (video.dataset.voVideoReady === 'true') return;

      video.dataset.voVideoReady = 'true';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      video.addEventListener('loadeddata', function () {
        if (video === getActiveVideo(videos)) {
          section.classList.remove('is-video-fallback');
          syncVideoUi(section, video);
        }
      });

      video.addEventListener('play', function () {
        if (video === getActiveVideo(videos)) {
          syncVideoUi(section, video);
        }
      });

      video.addEventListener('playing', function () {
        if (video === getActiveVideo(videos)) {
          section.classList.remove('is-video-fallback');
          syncVideoUi(section, video);
        }
      });

      video.addEventListener('pause', function () {
        if (video === getActiveVideo(videos)) {
          syncVideoUi(section, video);
        }
      });

      video.addEventListener('volumechange', function () {
        if (video === getActiveVideo(videos)) {
          syncVideoUi(section, video);
        }
      });

      ['error', 'stalled', 'abort'].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          if (video === getActiveVideo(videos)) {
            section.classList.add('is-video-fallback');
          }
        });
      });
    });

    syncActiveVideo();

    if (playButton) {
      playButton.addEventListener('click', function () {
        var activeVideo = getActiveVideo(videos);

        if (!activeVideo) return;

        if (activeVideo.paused) {
          requestPlayback(activeVideo);
        } else {
          activeVideo.pause();
          syncVideoUi(section, activeVideo);
        }
      });
    }

    if (audioButton) {
      audioButton.addEventListener('click', function () {
        var activeVideo = getActiveVideo(videos);

        if (!activeVideo) return;

        activeVideo.muted = !activeVideo.muted;
        if (activeVideo.paused) {
          requestPlayback(activeVideo);
        } else {
          syncVideoUi(section, activeVideo);
        }
      });
    }

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', syncActiveVideo);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(syncActiveVideo);
    }
  }

  function initCursor(section) {
    var cursor = section.querySelector('[data-vo-cursor]');
    var hotspot = section.querySelector('.vo-full-width-banner__media-link');

    if (!cursor || !hotspot || cursor.dataset.voCursorReady === 'true') return;

    cursor.dataset.voCursorReady = 'true';

    hotspot.addEventListener('pointerenter', function () {
      cursor.classList.add('is-visible');
    });

    hotspot.addEventListener('pointerleave', function () {
      cursor.classList.remove('is-visible');
    });

    hotspot.addEventListener('pointermove', function (event) {
      var bounds = hotspot.getBoundingClientRect();
      var x = event.clientX - bounds.left;
      var y = event.clientY - bounds.top;

      cursor.style.setProperty('--vo-cursor-x', x + 'px');
      cursor.style.setProperty('--vo-cursor-y', y + 'px');
    });
  }

  function initSection(section) {
    if (!section || section.dataset.voBannerReady === 'true') return;

    section.dataset.voBannerReady = 'true';

    initCountdown(section);
    initVideo(section);
    initCursor(section);
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-vo-banner-root]')) {
      initSection(scope);
    }

    var sections = scope.querySelectorAll('[data-vo-banner-root]');

    sections.forEach(initSection);
  }

  window.__voInitFullWidthBanners = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
